import { render, staticRenderFns } from "./TrafficAnalytics.vue?vue&type=template&id=1da35dcc"
import script from "./TrafficAnalytics.vue?vue&type=script&lang=js"
export * from "./TrafficAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports